import React, { Component } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';

import CommonTokenExpired from './components/CommonTokenExpired';

import Cookies from "js-cookie";

/** withRouter */
import withRouter from "./components/withRouter"

/** start individual component */
import InputCommonDataAcademy from './inputs/InputCommonDataAcademy';
import SearchCommonDataAcademy from './searchs/SearchCommonDataAcademy';
import DataTableCommonDataAcademy from './dataTables/DataTableCommonDataAcademy';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/CommonDataAcademyState';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `academy`;
const URL = `api/master/${TABLE}`;

const rawProfile = Cookies.get("userProfile");
const userProfile = rawProfile ? JSON.parse(rawProfile) : {};

const allowedTypes = ["0", "1"]; // 0 = admin, 1 = EEC staff
const userPermit = allowedTypes.includes(userProfile.types);

class CommonDataAcademy extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
        await this.loadDataTable();
        await this.setDefaultSearchs();
    }

    loadMasterbase = async () => {        
        let sets = [
            { key: "education_type", filter: [{field: "status", value: "0"}] }, 
            { key: "education_area", filter: [{field: "status", value: "0"}] },
                    
            { key: "ministry", filter: [{field: "status", value: "0"}] },
            { key: "office_department", filter: [{field: "status", value: "0"}] }, 
            { key: "office_division", filter: [{field: "status", value: "0"}]} ,
        
            { key: "region", filter: [] },
            { key: "province", filter: [] }, 
            { key: "district", filter: [] }, 
            { key: "subdistrict", filter: [] }
        ]; 
        
        await Actions.loadMasterbase(this.updateState, sets);
    }

    loadDataTable = async (search = false) => { 
        const { Searchs, DataTable } = this.state;

        const cookieSearchs = {};
        if (userProfile.academy_id && (!['0', '1'].includes(userProfile.types)) ) { // 3 = enterprise user
            cookieSearchs.academy_id = { id: "id", value: userProfile.academy_id };
        }
        
        const mergedSearchs = {
            ...Searchs,
            ...cookieSearchs,
            page: {
            id: "page",
            value: search ? 1 : DataTable.pagination.currentPage,
            },
        };

        await Actions.loadDataTable(
            this.updateState,
            `${URL}/pagination`,
            fn.getInputSearch(mergedSearchs)
        );
    }
    
    setDefaultSearchs = async () => {
        let defaultsSearchs = {};
         switch (userProfile.types) {
            case "2": // academy
                defaultsSearchs.th_name = userProfile.academy_name;
            break;
            default:
                //(admin) ไม่เซ็ตค่า
            break;
        }
        await Actions.setDefaultSearchs(this.updateState,defaultsSearchs); 
        
    }

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'OffCanvas', mode: 'update', bool: true}
        );
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable
        );
    }
    
    componentDidMount = async () => {
        await this.initialize(); 
    }

    componentDidUpdate = async () => {}    

    render = () => {

        let { Action, Searchs, DataTable, Inputs, InputGroup, Masterbase, Deletes, Operation, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader object={AppProps}/>

                    <CommonTokenExpired Token={Token} />

                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        userPermit={userPermit}
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchCommonDataAcademy 
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableCommonDataAcademy 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        onDropDownChange={async(e, element, pk) => { await this.updateSomething(e, element, pk)} }

                        onCheckDelete={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)}
                        onCheckDeleteAll={(e, deletes) => Actions.handleDataTableToggleDeleteAll(this.updateState, e, deletes)}
                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                    <InputCommonDataAcademy 
                        URL={URL}
                        
                        App={AppProps}

                        Action={Action}
                        Inputs={Inputs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                        onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}

                        onSubmit={async (e) => { await this.submitData()}}
                        
                        onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                        onClose={(e) => {
                                Actions.handleDiscardInputs(this.updateState, 'Inputs');
                                Actions.handleCloseInputForm(this.updateState, 'OffCanvas')
                            }
                        }
                    />

                </Container>
            </>
        )
    }
}

export default withRouter(CommonDataAcademy);